import React, { useState, useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import api from '../../../services/api';
import { parseTableParams, formatDate } from '../../../utils/Utils';
import DataTable from '../../../components/ui/DataTable';
import LoadErrorBanner from '../../../components/ui/LoadErrorBanner';
import { readPage } from '../../../utils/apiResult';

// Task 35 — havuz genelinde not listesi (Notlar sekmesi). Notların KENDİSİ okuma/
// yazma açısından hâlâ (poolId, employeeId) çiftine bağlı — yeni bir not eklemek için
// PoolMembersTab'deki üye satırından "Notlar" aksiyonu kullanılır (hangi çalışan
// hakkında olduğu orada bellidir). Bu sekme yalnız GÖRÜNTÜLEME sağlar (Task 35
// boşluk-doldurma — GetPoolNotesAsync).
//
// Task 35 fix turu (İncelemeci Important #2) — uç yalnız pageNumber/pageSize bind eder,
// filtre/sıralama YOK; bu yüzden tüm kolonlar filter:false/sort:false ve DataTable'ın
// filtre paneli `disableFilters` ile tamamen kapatıldı (aksi halde `dateFilterColumn`'ın
// ürettiği tarih aralığı filtresi/sıralaması sessizce no-op kalırdı — T31 sınıfı bulgu).
export default function PoolNotesTab({ poolId }) {
  const { t, i18n } = useTranslation();
  const lang = i18n.language;

  const [queryParams, setQueryParams] = useState({ pageSize: 10, pageNumber: 1 });
  const [data, setData] = useState([]);
  const [pagination, setPagination] = useState({ totalRowCount: 0, pageIndex: 0, pageSize: 10 });
  const [fetching, setFetching] = useState(true);
  // TD-23 (kalan yüzeyler, Faz 2) — başarısız okuma ile boş liste AYRI. Bkz.
  // utils/apiResult.js: api.js interceptor'ı GET'lerde reject ETMEZ, gerçek
  // sinyal `res.data.status`'tur; `.catch()` dalı ölü koddu ve hata sessizce
  // "kayıt yok" olarak görünüyordu.
  const [loadFailed, setLoadFailed] = useState(false);

  useEffect(() => {
    if (!poolId) return;
    setFetching(true);
    api.get(`/v1/talent-pool/pools/${poolId}/notes?${new URLSearchParams(queryParams)}`)
      .then((res) => {
        const { ok, items, pagination: page } = readPage(res);
        setLoadFailed(!ok);
        setData(items);
        setPagination(page);
      })
      .finally(() => setFetching(false));
  }, [poolId, queryParams]);

  const columns = useMemo(() => [
    { name: 'id', label: 'ID', options: { filter: false, sort: false, display: 'excluded' } },
    {
      name: 'employeeName',
      label: t('performance.talentpool.member'),
      options: { filter: false, sort: false },
    },
    {
      name: 'text',
      label: t('performance.talentpool.tabNotes'),
      options: { filter: false, sort: false },
    },
    {
      name: 'createDate',
      label: t('performance.common.createDate'),
      options: {
        filter: false, sort: false,
        customBodyRender: (v) => formatDate(v, lang),
      },
    },
  ], [t, lang]);

  const handleDataStateChange = (action, tableState) => {
    setQueryParams(parseTableParams(tableState, columns));
  };

  return (
    <>
      {loadFailed && <LoadErrorBanner />}
      <DataTable
      title={t('performance.talentpool.tabNotes')}
      fetching={fetching}
      columns={columns}
      data={data}
      totalRowCount={pagination.totalRowCount}
      pageIndex={pagination.pageIndex}
      pageSize={pagination.pageSize}
      disableFilters
      onTableChanged={handleDataStateChange}
      />
    </>
  );
}
